export enum CONCILIATION_STATUS {
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING_ACCEPT = 'PENDING_ACCEPT',
  COMPLETED = 'COMPLETED',
}

export enum CONCILIATION_TYPE {
  SUPPLIER = 'SUPPLIER',
  LOGISTIC = 'LOGISTIC',
  CARRIER = 'CARRIER',
  DRIVER = 'DRIVER',
  WAREHOUSE = 'WAREHOUSE',
  DISTRIBUTION_CENTER = 'DISTRIBUTION_CENTER',
}

export enum CONCILIATION_QUERY_TYPE {
  SUPPLIER = 'supplier',
  LOGISTIC = 'logistic',
  CARRIER = 'carrier',
}

export enum SEGMENT_TYPE {
  ORDERS = 'Orders',
  ITEMS = 'Items',
  REIMBURSEMENT = 'Reimbursements',
  REIMBURSEMENTS_ITEMS = 'ReimbursementsItems',
  MOVEMENTS = 'Movements',
  MAIN = 'Main',
  GENERAL = 'General',
}

export const CONCILIATION_SERVICE_MAP = {
  [CONCILIATION_TYPE.LOGISTIC]: 'logistic-conciliation',
  [CONCILIATION_TYPE.SUPPLIER]: 'supplier-conciliation',
  [CONCILIATION_TYPE.CARRIER]: 'carrier-conciliation',
  [CONCILIATION_TYPE.WAREHOUSE]: 'warehouse-conciliation',
  [CONCILIATION_TYPE.DISTRIBUTION_CENTER]: 'dc-conciliation',
  [CONCILIATION_TYPE.DRIVER]: 'driver-conciliation',
};

export enum SUPPLIER_CONCILIATION_METRIC {
  PRODUCTS = 'products',
  INCIDENCES = 'incidences',
  STOCK_COMPENSATION = 'stock-compensation',
  STOCK_ACTIVITY_RETURN = 'stock-activity-return',
  ADJUSTMENT = 'adjustment',
}

export enum LOGISTIC_CONCILIATION_METRIC {
  PRODUCTS = 'products',
  ORDERS = 'orders',
  INCIDENCES = 'incidences',
  ADJUSTMENT = 'adjustment',
  STOCK_CHARGE = 'stock-charge',
}

export enum CARRIER_CONCILIATION_METRIC {
  DRIVERS = 'drivers',
  ORDERS = 'suborders',
  INCIDENCES = 'incidences',
  ADJUSTMENT = 'adjustment',
  STOCK_CHARGE = 'stock-charge',
  PAYMENT_AGREEMENT = 'payment-agreements',
}

export enum WAREHOUSE_CONCILIATION_METRIC {
  STOCK_CHARGE = 'stock-charge',
  INCIDENCES = 'incidences',
  ADJUSTMENT = 'adjustment',
}

export enum DC_CONCILIATION_METRIC {
  ORDERS = 'orders',
  INCIDENCES = 'incidences',
  STOCK_CHARGE = 'stock-charge',
  ADJUSTMENT = 'adjustment',
}

export enum CONCILIATION_METRIC {
  SUMMARY = 'summary',
  HISTOGRAM = 'histogram',
}

export enum DRIVER_CONCILIATION_METRIC {
  ORDERS = 'suborders',
  INCIDENCES = 'incidences',
  ADJUSTMENT = 'adjustment',
  STOCK_CHARGE = 'stock-charge',
  PAYMENT_AGREEMENT = 'payment-agreements',
}
